var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoutIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.31602 7.3837C5.96604 7.3837 5.6893 7.65569 5.6893 7.99967C5.6893 8.33566 5.96604 8.61565 6.31602 8.61565H11.1995V12.4395C11.1995 14.3994 9.57984 15.9993 7.5776 15.9993H3.61381C1.6197 15.9993 0 14.4074 0 12.4475V3.55985C0 1.59194 1.62784 0 3.62195 0H7.59388C9.57984 0 11.1995 1.59194 11.1995 3.55186V7.3837H6.31602ZM14.1036 5.23192L16.4395 7.55983C16.5595 7.67982 16.6235 7.83182 16.6235 7.99981C16.6235 8.15981 16.5595 8.3198 16.4395 8.43179L14.1036 10.7597C13.9836 10.8797 13.8236 10.9437 13.6716 10.9437C13.5116 10.9437 13.3517 10.8797 13.2317 10.7597C12.9917 10.5197 12.9917 10.1277 13.2317 9.88773L14.5116 8.61579H11.1997V7.38384H14.5116L13.2317 6.11189C12.9917 5.8719 12.9917 5.47991 13.2317 5.23992C13.4716 4.99193 13.8636 4.99193 14.1036 5.23192Z",
    fill: "#31414E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.e657abb188be6e366c3e96ee70773271.svg";
export { ForwardRef as ReactComponent };